import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isLoading: true,
  ordersCache: {},  // Cache for orders
  orders: null,
  error: null,
  success: false,
};

export const orderReducer = createReducer(initialState, (builder) => {
  builder
    .addCase("getAllOrderUserRequest", (state) => {
      state.isLoading = true;
      state.error = null;
    })
    .addCase("getAllOrderUserSuccess", (state, action) => {
      state.isLoading = false;
      const { data, cacheKey } = action.payload;

      // Store the fetched data in cache
      state.ordersCache[cacheKey] = data;
      state.orders = data;
      state.success = true;
    })
    .addCase("getAllOrderUserFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    .addCase("getAllOrderUserCached", (state, action) => {
      state.isLoading = false;
      state.orders = action.payload;
      state.success = true;
    });
});
